/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkflowActionType = {
    EXECUTE: 'EXECUTE',
    PROPOSE: 'PROPOSE',
    SECOND: 'SECOND',
    APPROVE: 'APPROVE',
    CANCEL: 'CANCEL',
    FAIL: 'FAIL',
    COMPLETE: 'COMPLETE',
    INCOMPLETE: 'INCOMPLETE'
} as const;
export type WorkflowActionType = typeof WorkflowActionType[keyof typeof WorkflowActionType];


export function WorkflowActionTypeFromJSON(json: any): WorkflowActionType {
    return WorkflowActionTypeFromJSONTyped(json, false);
}

export function WorkflowActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowActionType {
    return json as WorkflowActionType;
}

export function WorkflowActionTypeToJSON(value?: WorkflowActionType | null): any {
    return value as any;
}

